import React from 'react'
import {connect} from 'react-redux'
import {getFlash} from 'state/actions'
import Grail from 'elements/Grail'
import underscore from 'underscore'
import Version from './version'
import Disclaimer from './disclaimer'
import HtmlContent from 'elements/HtmlContent'
import styles from './metroUI.scss'

import i18n from 'lib/i18n'
const _ = i18n('sidebar')

@connect(state => ({
	flash: state.flash.items,
	menuItems: state.app.security && state.app.security.menuItems || [],
	isPhone: state.responsive.isPhone,
	isTablet: state.responsive.isTablet,
	unreadCount: state.inbox.unreadCount,
	taskCount: state.taskList.uncompleted,
	outboxFailedCount: state.outbox.outboxFailedCount,
	newNewsCount: state.news.newNewsCount
}))
export default class MetroUI extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		flash: React.PropTypes.array.isRequired,
		menuItems: React.PropTypes.array.isRequired,
		isPhone: React.PropTypes.bool.isRequired,
		isTablet: React.PropTypes.bool.isRequired,
		onLinkClicked: React.PropTypes.func.isRequired,
		onFlashClicked: React.PropTypes.func.isRequired,
		onLogout: React.PropTypes.func.isRequired,
	}

	componentDidMount() {this.update(true)}
	componentDidUpdate() {this.update()}
	update(force) {this.props.dispatch(getFlash(force))}

	getCountIndicatorValue (item) {
		return (item.menuName === 'inbox' && this.props.unreadCount)
		|| (item.menuName === 'tasklist' && this.props.taskCount)
		|| (item.menuName === 'outbox' && this.props.outboxFailedCount)
		|| (item.menuName === 'news' && this.props.newNewsCount)
	}
		
	render() {
		const {flash, menuItems, isPhone, isTablet} = this.props
		const links = menuItems.filter(item => (item.menuVisible === "true"))
	
		let icons = links.map((item, i) => {
			try {
				return require(`resources/images/m-${item.menuName}.svg`)
			}catch(err){
				return require(`resources/images/icn-no-result.svg`)
			}
		})
		return (
			<Grail
				noScroll
				footer={
					<div className={styles.disclaimer}>
						<Disclaimer/>
						- <span className={styles.version}>
							<Version/>
						</span>
					</div>
				}
			>
				<div className={`${styles.metroUI} ${((isPhone || isTablet) && styles.mobile)}`}>
					<div className={styles.metroUIContainer}>
						<div className={styles.metroUICenterContainer}>
							<div className={styles.metroUILogo}>
								<img src={require("resources/images/BE_Logo_OVB_Willemot_Blue_cmyk.svg")}/>
							</div>

							{links.map((item, i) => {
								let actFlash 
								if (i === (isPhone || isTablet ? 2 : 0)) {
									actFlash = flash[0]
									if(actFlash){
										actFlash.className = 'flashOne'
									}
								} else if (i === (isPhone || isTablet ? 8 : 5)) {
									actFlash = flash[1]
									if(actFlash) {
										actFlash.className = 'flashTwo'
									}
								}
								let src
								const count = this.getCountIndicatorValue(item)
								if (actFlash) {
									const html = actFlash.teaser
									src
									const htmlSrcMatches = html.match(new RegExp(/src\s*=\s*"(.+?)"/))
									if (!underscore.isEmpty(htmlSrcMatches) && underscore.isArray(htmlSrcMatches)
										&& htmlSrcMatches.length > 1) {
										src = htmlSrcMatches[1]
									}
								}
								return (
									<div key={i} className={styles.tileWrapper}>
										{/* This is a real comment */}
										{/* onMouseup required because of Edge - it's not handling the onClick */}
										<div
											id={i}
											onMouseUp={() => this.props.onLinkClicked(item.menuName)}
											className={`${styles.tile} ${styles[item.menuName]}`}
										>
											
											<div className={styles.tileHeading}>
												<div className={styles.iconContainer}>
													<img src={icons[i] || ""}/>
												</div>
												<div className={styles.tileTitle}>
													{item.menuLabel || _(item.menuName)}
												</div>
												{count > 0 && <div className={styles.counter}>{count}</div>}

											</div>
										</div>
										{actFlash &&
											<div
												onClick={() => this.props.onFlashClicked(actFlash._id)}
												className={`${styles.tile} ${styles[actFlash.className]} ${styles.markdown}`}
											>
												<div style={{'backgroundImage': `url(${src})`, 'backgroundSize': 'cover', 'backgroundPosition': 'center'}} className={styles.tileHeading}>
													<div className={styles.tileTitle}>{actFlash.title}</div>
													<div className={src ? `${styles.tileTeaser} ${styles.noImg}` : styles.tileTeaser}>
														<HtmlContent
															className=""
															content={actFlash.teaser}
														/>
													</div>
												</div>
											</div>
										}
									</div>
								)
							})}

							<div
								id="casper_logout"
								onClick={() => this.props.onLogout()}
								className={`${styles.tile} ${styles.logout}`}
							>
								<div className={styles.tileHeading}>
									<div className={styles.iconContainer}>
										<img src={require(`resources/images/m-logout.svg`)}/>
									</div>
									<div className={styles.tileTitle}>
										{_("logout")}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Grail>
		)
	}
}



// WEBPACK FOOTER //
// ./components/metroUI.jsx